// components/ref-tracker.tsx
'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { refApi } from '@/lib/salesman-api';

const COOKIE_NAME = 'ref_code';
const DAYS_30 = 30 * 24 * 60 * 60;

function setRefCookie(code: string) {
  const attrs = [
    `${COOKIE_NAME}=${encodeURIComponent(code)}`,
    `Path=/`,
    `Max-Age=${DAYS_30}`,
    `SameSite=Lax`,
  ];
  if (window.location.protocol === 'https:') attrs.push('Secure');
  document.cookie = attrs.join('; ');
}

/** Кладёт ?ref=CODE в cookie на 30 дней и пингует /ref/click. Ставится в глобальный layout. */
export function RefTracker() {
  const params = useSearchParams();
  const pathname = usePathname();

  useEffect(() => {
    const code = params?.get('ref');
    if (!code) return;
    setRefCookie(code);
    refApi.click(code);
  }, [params, pathname]);

  return null;
}